// extracted by mini-css-extract-plugin
export default {"formbar":"ActivityList_formbar__MS5zg","wrapper":"ActivityList_wrapper__6RbRj"};